var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 54,
    viewBox: "0 0 40 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_516_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 14.3438V0H2.5C1.11458 0 0 1.12852 0 2.53125V51.4688C0 52.8715 1.11458 54 2.5 54H37.5C38.8854 54 40 52.8715 40 51.4688V16.875H25.8333C24.4583 16.875 23.3333 15.7359 23.3333 14.3438ZM30 39.2344C30 39.9305 29.4375 40.5 28.75 40.5H11.25C10.5625 40.5 10 39.9305 10 39.2344V38.3906C10 37.6945 10.5625 37.125 11.25 37.125H28.75C29.4375 37.125 30 37.6945 30 38.3906V39.2344ZM23.25 32.4844C23.25 33.1805 22.6875 33.75 22 33.75H11.25C10.5625 33.75 10 33.1805 10 32.4844V31.6406C10 30.9445 10.5625 30.375 11.25 30.375H22C22.6875 30.375 23.25 30.9445 23.25 31.6406V32.4844ZM30 24.8906V25.7344C30 26.4305 29.4375 27 28.75 27H11.25C10.5625 27 10 26.4305 10 25.7344V24.8906C10 24.1945 10.5625 23.625 11.25 23.625H28.75C29.4375 23.625 30 24.1945 30 24.8906ZM40 12.8566V13.5H26.6667V0H27.3021C27.9688 0 28.6042 0.263672 29.0729 0.738281L39.2708 11.0742C39.7396 11.5488 40 12.1922 40 12.8566Z",
    fill: "url(#paint0_linear_516_8)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_516_8",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB500"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_516_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 54,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.31f3749d34439be82e24976321b1bd5f.svg";
export { ForwardRef as ReactComponent };